import {defineMessages} from 'react-intl'

export default defineMessages({
    commentLabel: {
        id: 'containers.ProjectPage.components.ProjectVote.commentLabel',
        defaultMessage: 'Comment'
    },
    pageTitle: {
        id: 'containers.ProjectPage.components.ProjectVote.pageTitle',
        defaultMessage: 'Cast your vote'
    },
    commentInputPlaceholder: {
        id: 'containers.ProjectPage.components.ProjectVote.commentInputPlaceholder',
        defaultMessage: 'Want to add a note to your votes?'
    },
    labelName: {
        id: 'containers.ProjectPage.components.ProjectVote.labelName',
        defaultMessage: 'Your full name'
    },
    labelEmail: {
        id: 'containers.ProjectPage.components.ProjectVote.labelEmail',
        defaultMessage: 'E-mail'
    },
    buttonLoading: {
        id: 'containers.ProjectPage.components.ProjectVote.buttonLoading',
        defaultMessage: 'Loading..'
    },
    buttonSubmit: {
        id: 'containers.ProjectPage.components.ProjectVote.buttonSubmit',
        defaultMessage: 'Submit my vote'
    },
    bannerSucessState: {
        id: 'containers.ProjectPage.components.ProjectVote.bannerSucessState',
        defaultMessage: "success"
    },
    bannerSucessTitle: {
        id: 'containers.ProjectPage.components.ProjectVote.bannerSucessTitle',
        defaultMessage: "We have received your vote"
    },
    bannerSucessSubTitle: {
        id: 'containers.ProjectPage.components.ProjectVote.bannerSucessSubTitle',
        defaultMessage: "Your vote will be automatically forwarded to the person who share this link with you."
    }


})
